export const countryCodeMap = {
    "Bahrain": "BH",
    "Saudi Arabia": "SA",
    "Australia": "AU",
    "Japan": "JP",
    "China": "CN",
    "United States": "US", // ✅ use full name
    "USA": "US",
    "Mexico": "MX",
    "Brazil": "BR",
    "Qatar": "QA",
    "United Kingdom": "GB", // ✅ for UK
    "UK": "GB",
    "UAE": "AE",
    "United Arab Emirates": "AE",
    "Azerbaijan": "AZ",
    "Italy": "IT",
    "Spain": "ES",
    "Monaco": "MC",
    "Singapore": "SG",
    "Netherlands": "NL",
    "Belgium": "BE",
    "Hungary": "HU",
    "Austria": "AT",
    "Canada": "CA",
    "France": "FR",
    "Germany": "DE",
  };
  
  